import HttpQuery from "@mnjsplatform/data/lib/api/HttpQuery";

class HomeApi {
    static loadInitialData() {
        let hq = new HttpQuery();
        return hq.makeApiCall("PaHome/Ping");
    }

    static loadBadges() {
        let hq = new HttpQuery();
        return hq.makeApiCallPost("PaHome/GetBadges", {});
    }

    static quitSession() {
        let hq = new HttpQuery();
        return hq.makeApiCall("PaHome/QuitSession");
    }
}

export default HomeApi
